import {
  homeSearchIcon,
  newListingIcon,
  questionsSupportIcon,
  savedListingIcon
} from "./assets";

export const ICONS = [
  {
    src: questionsSupportIcon,
    key: "questions-support-icon",
    text: "Tell us your needs"
  },
  {
    src: savedListingIcon,
    key: "saved-listing-icon",
    text: "Save your top searches"
  },
  {
    src: newListingIcon,
    key: "new-listing-icon",
    text: "See new listings instantly"
  },
  {
    src: homeSearchIcon,
    key: "home-search-icon",
    text: "Get the right home for you"
  }
];
